import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './networking'
import $ from 'jquery';
import { Picker , Popup ,Loading ,Uploader} from 'vant';
import 'vant/lib/index.css';
createApp(App).use(Picker).use(Uploader).use(Popup).use(Loading).use($).use(store).use(router).mount('#app')
